import React, { useCallback, useEffect, useState } from "react";
import KlubbVelger, { getKlubbId } from "./KlubbVelger";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function Innkjopsansvarlige() {
  const [assignments, setAssignments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/klubbsystem/purchasers?clubId=${getKlubbId()}`);
      if (!res.ok) throw new Error("Kunne ikke hente innkjøpsansvarlige");
      const data = await res.json();
      data.sort((a, b) => (a.teamId?.name || "").localeCompare(b.teamId?.name || ""));
      setAssignments(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="max-w-3xl mx-auto py-10 px-4">
      <span className="inline-block px-2.5 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold mb-3">
        Klubb
      </span>
      <h1 className="text-2xl font-semibold text-gray-900 mb-1">Innkjøpsansvarlige</h1>
      <p className="text-gray-500 mb-6">
        Hvem som er godkjent av klubben til å bestille varer for hvert lag, hentet fra klubbsport1.
      </p>

      <KlubbVelger onChange={load} />

      {loading && <p className="text-gray-400 text-sm">Laster …</p>}
      {error && <p className="text-red-600 text-sm">{error}</p>}

      {!loading && !error && (
        assignments.length === 0 ? (
          <p className="text-gray-400 text-sm">Ingen innkjøpsansvarlige er registrert ennå.</p>
        ) : (
          <div className="border border-gray-200 rounded-xl overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wide">
                  <tr>
                    <th className="text-left px-4 py-2.5">Lag</th>
                    <th className="text-left px-4 py-2.5">Innkjøpsansvarlig</th>
                    <th className="text-left px-4 py-2.5">E-post</th>
                    <th className="text-left px-4 py-2.5">Telefon</th>
                  </tr>
                </thead>
                <tbody>
                  {assignments.map((a) => (
                    <tr key={a._id} className="border-t border-gray-100">
                      <td className="px-4 py-2.5 font-medium text-gray-900">{a.teamId?.name || "Hele klubben"}</td>
                      <td className="px-4 py-2.5">{a.personId?.name || "—"}</td>
                      <td className="px-4 py-2.5 text-gray-500">{a.personId?.email || "—"}</td>
                      <td className="px-4 py-2.5 text-gray-500">{a.personId?.phone || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )
      )}
    </div>
  );
}
